import { render, staticRenderFns } from "./courseCreateTimeline_new.vue?vue&type=template&id=0dae9e4b&scoped=true"
import script from "./courseCreateTimeline_new.vue?vue&type=script&lang=js"
export * from "./courseCreateTimeline_new.vue?vue&type=script&lang=js"
import style0 from "./courseCreateTimeline_new.vue?vue&type=style&index=0&id=0dae9e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae9e4b",
  null
  
)

export default component.exports